export type Movie = {
  id: string;
  title: string;
  type: 'movie' | 'series' | 'animation';
  genre: string[];
  year: number;
  rating: number;
  duration: string;
  language: string;
  poster: string;
  description: string;
  badge?: string;
};

export const movieCategories = [
  { id: 'all', label: 'الكل' },
  { id: 'movie', label: 'أفلام' },
  { id: 'series', label: 'مسلسلات' },
  { id: 'animation', label: 'رسوم متحركة' },
  { id: 'action', label: 'أكشن' },
  { id: 'drama', label: 'دراما' },
  { id: 'comedy', label: 'كوميدي' },
  { id: 'thriller', label: 'إثارة' },
  { id: 'romance', label: 'رومانسي' },
];

export const movies: Movie[] = [
  {
    id: 'm1',
    title: 'رحلة الأسطورة',
    type: 'movie',
    genre: ['أكشن', 'مغامرة'],
    year: 2024,
    rating: 8.7,
    duration: '2س 18د',
    language: 'عربي',
    poster: 'https://public.readdy.ai/ai/img_res/e7ee0d67caf6bf19e95a03638b3466a2.jpg',
    description: 'رحلة ملحمية عبر الصحراء العربية يخوضها بطل شجاع في مواجهة قوى الظلام لإنقاذ مملكته.',
    badge: 'الأعلى تقييماً',
  },
  {
    id: 'm2',
    title: 'أسرار الليل',
    type: 'series',
    genre: ['دراما', 'إثارة'],
    year: 2024,
    rating: 9.1,
    duration: '3 مواسم',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=dramatic%20Arabic%20TV%20series%20poster%20with%20mysterious%20nighttime%20city%20skyline%2C%20moonlit%20rooftop%20silhouettes%2C%20suspenseful%20noir%20atmosphere%2C%20deep%20blue%20and%20gold%20color%20palette%2C%20cinematic%20professional%20series%20poster%20design%2C%20mysterious%20characters%20in%20shadows&width=400&height=580&seq=mv2&orientation=portrait',
    description: 'مسلسل درامي مثير يكشف أسرار مخفية وراء واجهات المجتمع الراقي في مدينة عربية حديثة.',
    badge: 'جديد',
  },
  {
    id: 'm3',
    title: 'قلب من ذهب',
    type: 'series',
    genre: ['رومانسي', 'دراما'],
    year: 2023,
    rating: 8.4,
    duration: '2 مواسم',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=romantic%20Arabic%20drama%20TV%20series%20poster%20with%20two%20lovers%20at%20golden%20sunset%2C%20warm%20amber%20orange%20tones%2C%20soft%20cinematic%20lighting%2C%20emotional%20romance%20poster%20art%2C%20elegant%20Arabic%20style%20design%2C%20beautiful%20landscape%20in%20background&width=400&height=580&seq=mv3&orientation=portrait',
    description: 'قصة حب عميقة بين شابين من عالمين مختلفين تواجه عقبات المجتمع والأسرة والقدر.',
    badge: undefined,
  },
  {
    id: 'm4',
    title: 'الظل الأسود',
    type: 'movie',
    genre: ['إثارة', 'جريمة'],
    year: 2024,
    rating: 8.2,
    duration: '1س 58د',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=dark%20thriller%20Arabic%20movie%20poster%20with%20shadowy%20detective%20figure%2C%20rain%20slicked%20city%20streets%20at%20night%2C%20noir%20crime%20atmosphere%2C%20dramatic%20black%20and%20white%20with%20red%20accents%2C%20professional%20cinematic%20movie%20poster%20design%2C%20mystery%20suspense%20film&width=400&height=580&seq=mv4&orientation=portrait',
    description: 'محقق متمرس يتعقب مجرماً غامضاً في شبكة من الكذب والخداع تمتد عبر مدن متعددة.',
    badge: undefined,
  },
  {
    id: 'm5',
    title: 'ضحكة القدر',
    type: 'movie',
    genre: ['كوميدي', 'رومانسي'],
    year: 2023,
    rating: 7.9,
    duration: '1س 45د',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=colorful%20fun%20Arabic%20comedy%20romantic%20movie%20poster%20with%20laughing%20couple%20in%20colorful%20city%20setting%2C%20vibrant%20cheerful%20colors%2C%20playful%20typography%2C%20bright%20sunny%20atmosphere%2C%20fun%20romantic%20comedy%20film%20poster%20design&width=400&height=580&seq=mv5&orientation=portrait',
    description: 'كوميديا رومانسية خفيفة عن لقاء عفوي يغيّر حياة شخصين بشكل لا يتوقعانه.',
    badge: undefined,
  },
  {
    id: 'm6',
    title: 'جذور الأجداد',
    type: 'series',
    genre: ['تاريخي', 'دراما'],
    year: 2024,
    rating: 9.3,
    duration: '1 موسم',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=epic%20historical%20Arabic%20TV%20series%20poster%20set%20in%20ancient%20Arabian%20civilization%2C%20grand%20palace%20architecture%2C%20warriors%20on%20horses%20in%20desert%20battle%2C%20rich%20golden%20tones%2C%20epic%20historical%20drama%20poster%20design%2C%20majestic%20and%20cinematic%20atmosphere&width=400&height=580&seq=mv6&orientation=portrait',
    description: 'ملحمة تاريخية تحكي نشوء إمبراطورية عربية عظيمة عبر أجيال من الكفاح والبناء.',
    badge: 'الأكثر مشاهدة',
  },
  {
    id: 'm7',
    title: 'عالم مقلوب',
    type: 'movie',
    genre: ['خيال علمي', 'أكشن'],
    year: 2024,
    rating: 8.0,
    duration: '2س 30د',
    language: 'مدبلج',
    poster: 'https://readdy.ai/api/search-image?query=sci-fi%20action%20movie%20poster%20with%20futuristic%20Arabic%20city%20in%20sky%2C%20flying%20vehicles%2C%20neon%20lights%2C%20dramatic%20blue%20and%20orange%20cinematic%20color%20grading%2C%20epic%20science%20fiction%20film%20poster%2C%20advanced%20technology%20cityscape&width=400&height=580&seq=mv7&orientation=portrait',
    description: 'في عالم مستقبلي، يكتشف شاب قدرات خارقة تجعله محط اهتمام قوى متصارعة.',
    badge: undefined,
  },
  {
    id: 'm8',
    title: 'بيت الأسرار',
    type: 'series',
    genre: ['دراما', 'أسرة'],
    year: 2023,
    rating: 8.6,
    duration: '4 مواسم',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=Arabic%20family%20drama%20TV%20series%20poster%20with%20traditional%20house%20architecture%2C%20warm%20indoor%20lighting%2C%20family%20silhouettes%2C%20emotional%20atmospheric%20composition%2C%20warm%20amber%20tones%2C%20professional%20TV%20series%20poster%20design%2C%20family%20secrets%20drama&width=400&height=580&seq=mv8&orientation=portrait',
    description: 'سيناريو عائلي مشوّق يتناول الصراعات الداخلية لعائلة عريقة تواجه ضغوط الحداثة.',
    badge: 'خاص',
  },
  {
    id: 'm9',
    title: 'الوجه الآخر',
    type: 'movie',
    genre: ['إثارة', 'نفسي'],
    year: 2024,
    rating: 8.5,
    duration: '2س 5د',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=psychological%20thriller%20Arabic%20movie%20poster%20with%20split%20face%20reflection%20concept%2C%20dark%20moody%20lighting%2C%20mirror%20imagery%2C%20deep%20psychological%20atmosphere%2C%20haunting%20cinematic%20poster%20design%2C%20mystery%20suspense%20film%20with%20duality%20theme&width=400&height=580&seq=mv12&orientation=portrait',
    description: 'فيلم نفسي مثير عن رجل يكتشف أن حياته الكاملة كانت وهماً مصطنعاً.',
    badge: undefined,
  },
  // ── Animations ──
  {
    id: 'a1',
    title: 'مملكة الرمال',
    type: 'animation',
    genre: ['مغامرة', 'خيال'],
    year: 2024,
    rating: 9.0,
    duration: '1س 35د',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=beautiful%20Arabian%20animated%20movie%20poster%20with%20cute%20young%20hero%20in%20magical%20golden%20desert%20kingdom%2C%20vibrant%20colorful%20animation%20art%20style%2C%20Disney%20Pixar%20quality%2C%20warm%20glowing%20sunset%20colors%2C%20enchanted%20sand%20dunes%20with%20floating%20islands%2C%20professional%20animated%20film%20poster&width=400&height=580&seq=an1&orientation=portrait',
    description: 'قصة مغامرة ملونة لطفل شجاع يكتشف مملكة سحرية مخبأة تحت رمال الصحراء.',
    badge: 'للعائلة',
  },
  {
    id: 'a2',
    title: 'الفارس الصغير',
    type: 'animation',
    genre: ['أكشن', 'مغامرة'],
    year: 2024,
    rating: 8.8,
    duration: '1س 42د',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=colorful%20Arabic%20animated%20adventure%20film%20poster%20with%20brave%20young%20boy%20riding%20magical%20horse%20through%20enchanted%20forest%2C%20vibrant%20animation%20style%2C%20bold%20heroic%20composition%2C%20rich%20warm%20colors%2C%20professional%20animated%20children%20movie%20poster%2C%20fantasy%20world&width=400&height=580&seq=an2&orientation=portrait',
    description: 'مغامرات فارس صغير يركب حصاناً سحرياً في رحلة لإنقاذ قريته من شرير قوي.',
    badge: 'جديد',
  },
  {
    id: 'a3',
    title: 'عالم الألوان',
    type: 'animation',
    genre: ['كوميدي', 'خيال'],
    year: 2023,
    rating: 8.6,
    duration: '45 دقيقة',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=joyful%20colorful%20animated%20series%20poster%20with%20funny%20cute%20cartoon%20characters%20in%20a%20magical%20rainbow%20world%2C%20bright%20vivid%20colors%2C%20cheerful%20fun%20animation%20style%2C%20children%20animated%20series%20poster%2C%20Cartoon%20Network%20style%2C%20playful%20typography&width=400&height=580&seq=an3&orientation=portrait',
    description: 'عالم كوميدي مبهج تعيش فيه شخصيات طريفة مغامرات يومية ملونة لا تنتهي.',
    badge: 'للأطفال',
  },
  {
    id: 'a4',
    title: 'نجوم الفضاء',
    type: 'animation',
    genre: ['خيال علمي', 'مغامرة'],
    year: 2024,
    rating: 8.9,
    duration: '2 مواسم',
    language: 'عربي',
    poster: 'https://readdy.ai/api/search-image?query=epic%20animated%20space%20adventure%20series%20poster%20with%20young%20Arab%20astronaut%20heroes%20exploring%20colorful%20galaxy%2C%20stunning%20cosmic%20scenery%2C%20vibrant%20sci-fi%20animation%20style%2C%20bright%20stars%20and%20planets%2C%20professional%20animated%20series%20poster%20design%2C%20family%20friendly&width=400&height=580&seq=an4&orientation=portrait',
    description: 'مجموعة من الأبطال الشباب يسافرون عبر المجرات لإنقاذ الكون من قوى الظلام.',
    badge: 'الأكثر مشاهدة',
  },
];
